<rx-banner
	*ngIf="showOfflineBanner$ | async"
	class="rx-intuitive-art-banners-orchestrator__banner"
	type="notification"
	appearance="intuitive"
	[showOfflineIcon]="true"
	[title]="'ArtTreatments.ART.Assets.Offline' | translate"
	[message]="'ArtTreatments.ART.Assets.Offline.Text' | translate"
></rx-banner>

<ng-container *ngIf="!(showOfflineBanner$ | async)">
	<rx-intuitive-patient-not-linked-banner
		*ngIf="(showPatientNotLinkedBanner$ | async) && !isPatientNotLinkedBannerDismissed"
		class="rx-intuitive-art-banners-orchestrator__banner"
		(dismissed)="dismissPatientNotLinkedBanner()"
	></rx-intuitive-patient-not-linked-banner>

	<rx-intuitive-missing-attachments-banner
		*ngIf="(showOrderMissingAttachmentsBanner$ | async) && !isOrderMissingAttachmentsBannerDismissed"
		class="rx-intuitive-art-banners-orchestrator__banner"
		(dismissed)="dismissOrderMissingAttachmentsBanner()"
	></rx-intuitive-missing-attachments-banner>
</ng-container>
